export const SITE = {
  name: 'Junk Kings',
  slogan: 'You Call! We Haul!',
  phoneDisplay: '(580) 275-0509',
  phoneHref: 'tel:+15802750509',
  email: 'hello@junkkings.com',
  area: 'Southern Oklahoma & North Texas',
  logo: 'https://cdn.magicpatterns.com/uploads/ivyaG7WCrUKcormoFc3xzU/ME0a7047018947ef05961a7ba7b4563a2e.jpg',
  banner: 'https://cdn.magicpatterns.com/uploads/vsgpRXuewT5g1bJzAhezZB/ME0a7047018947ef05961a7ba7b4563a2e.jpg',
  hours: 'Mon–Sat · 7am – 7pm',
  social: {
    facebook: 'https://facebook.com',
    instagram: 'https://instagram.com',
    tiktok: 'https://tiktok.com',
    youtube: 'https://youtube.com',
  },
}

export const NAV = [
  { label: 'Home', to: '/' },
  { label: 'Services', to: '/services' },
  { label: 'How It Works', to: '/how-it-works' },
  { label: 'Pricing', to: '/pricing' },
  { label: 'About', to: '/about' },
  { label: 'Contact', to: '/contact' },
]
